import { LoadingScreen } from '@/components/LoadingScreen'
import { useAuth } from './AuthContext'
import { useTranslation } from '@/i18n'

export function AuthErrorScreen({ fullscreen = true }: { fullscreen?: boolean }) {
  const { errorMessage, refreshAuthState, signOut, refreshing } = useAuth()
  const { t } = useTranslation()

  const card = (
    <div className="auth-error-card mx-auto w-full max-w-md rounded-3xl border border-red-900/50 bg-surface-900 p-8 shadow-[0_20px_80px_rgba(0,0,0,0.35)]">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-red-300/80">
        {t('Accountcontrole')}
      </p>
      <h1 className="mt-3 text-2xl font-black tracking-tight text-white">
        {t('Inloggen lukt nu even niet')}
      </h1>
      <p className="mt-3 text-sm leading-6 text-surface-300">
        {errorMessage ?? t('De app kon je accountstatus niet ophalen.')}
      </p>
      <div className="mt-6 flex flex-col gap-3">
        <button
          type="button"
          onClick={() => void refreshAuthState()}
          disabled={refreshing}
          className="rounded-2xl bg-accent-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-accent-500 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {t('Opnieuw proberen')}
        </button>
        <button
          type="button"
          onClick={() => void signOut()}
          disabled={refreshing}
          className="rounded-2xl border border-surface-700 px-4 py-3 text-sm font-semibold text-surface-200 transition hover:border-surface-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-60"
        >
          {t('Uitloggen')}
        </button>
      </div>
    </div>
  )

  if (!fullscreen) return card

  return <div className="auth-loading-shell flex min-h-screen items-center justify-center px-4">{card}</div>
}

export function AuthLoadingScreen({ fullscreen = true }: { fullscreen?: boolean }) {
  const { t } = useTranslation()
  if (fullscreen) {
    return <div className="auth-loading-shell min-h-screen"><LoadingScreen /></div>
  }

  return (
    <div className="auth-loading-state flex justify-center py-12">
      <div className="flex flex-col items-center gap-4">
        <div className="auth-loading-spinner h-10 w-10 animate-spin rounded-full border-4 border-surface-700 border-t-accent-500" />
        <p className="text-sm text-surface-400">{t('Laden...')}</p>
      </div>
    </div>
  )
}
